import { useLockedModules } from '@hooks/useLockedModules';
import type { FC, ReactNode } from 'react';

/**
 * Whether the brand may approve replenishment lines into documents. A brand whose plan locks
 * `plan.replenishment_approve` only saves: every Approve button in the planner goes, Save stays.
 * The approve endpoint refuses on its own too, so this is presentation, not the guard.
 */
const useCanApprove = (): boolean => !useLockedModules().isLocked('plan.replenishment_approve');

/** Renders its children (an Approve button) only for a brand that may approve. */
export const ApproveGate: FC<{ children: ReactNode }> = ({ children }) => (useCanApprove() ? <>{children}</> : null);
